import first from "lodash/first";
import type { FunctionComponent } from "react";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { checkIfNewsSectionInFirstIndex } from "~/lib/section";
import type { articleSectionsContent$key } from "~/queries/__generated__/articleSectionsContent.graphql";

import { SectionContainer, SectionLink, SectionTagsSpacer } from "./styles";

export type Props = {
  reference: articleSectionsContent$key;
};

export const ArticleSections: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { sections } = useFragment(
    graphql`
      fragment articleSectionsContent on Content {
        sections {
          value {
            ...helpersFilterSection
            ...entityLink
            name
          }
        }
      }
    `,
    reference_,
  );

  const firstSection = useMemo(() => first(sections)?.value ?? [], [sections]);

  // Confirmed with PO for only display two sections
  const sectionsForDisplay = useMemo(
    () =>
      firstSection
        .slice(-2)
        .filter((section, index) => !checkIfNewsSectionInFirstIndex(section, index)),
    [firstSection],
  );

  if (sectionsForDisplay.length === 0) return null;

  return (
    <SectionContainer>
      {sectionsForDisplay.map((section, index) =>
        section ? (
          <SectionLink key={index} reference={section}>
            <span>{section?.name}</span>
            {index < sectionsForDisplay.length - 1 ? (
              <SectionTagsSpacer>/</SectionTagsSpacer>
            ) : null}
          </SectionLink>
        ) : null,
      )}
    </SectionContainer>
  );
};

ArticleSections.displayName = "ArticleSections";
